import React from 'react';
import PropTypes from 'prop-types';
import { Column, Typography } from '@tempmee/react';

/**
 * A table cell's value with an optional secondary line beneath it, for a
 * label that needs a qualifier ("Indirect" / "via Bright Smiles DSO").
 * A falsy `caption` renders the label alone.
 */
export const CaptionedLabel = ({ label, caption }) => (
  <Column>
    <Typography variant="body2">{label}</Typography>
    {caption ? (
      <Typography variant="caption" className="text-text-secondary">
        {caption}
      </Typography>
    ) : null}
  </Column>
);

CaptionedLabel.propTypes = {
  label: PropTypes.node.isRequired,
  caption: PropTypes.node,
};

CaptionedLabel.defaultProps = {
  caption: null,
};

export default CaptionedLabel;
